import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import useRedirect from '#hooks/useRedirect';
import messages from './messages';

type MessageType = ReturnType<typeof useIntlMessage>;
type UrlType = ReturnType<typeof useRedirect>['urlToLivePage'];

const DataLinks = (formatMessage: MessageType, urlToLivePage: UrlType, provenemployer?: boolean) => [
  {
    label: formatMessage(messages.termsAndConditions),
    href: urlToLivePage('termsAndConditionsOfUse', provenemployer),
  },
  {
    label: formatMessage(messages.privacyPolicy),
    href: urlToLivePage('privacyPolicy', provenemployer),
  },
  {
    label: formatMessage(messages.qualityAssurance),
    href: urlToLivePage('qualityAssurance', provenemployer),
  },
  {
    label: formatMessage(messages.legalNotice),
    href: urlToLivePage('legalNotice', provenemployer),
  },
];

export default DataLinks;
